import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  AccountReceivableModel,
  AccountReceiveableCustomerLiteModel,
  AccountReceiveableLiteModel,
  getAccountReceivableAgentInput,
  getAccountReceivableInput,
  getAccountReceivablesInput,
} from './model';

export function useGetAccountReceivables(
  input?: getAccountReceivablesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<AccountReceiveableLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<AccountReceiveableLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['account-receivables', input?.params],
      () =>
        QueryFetchFunction({
          url: 'account-receivables',
          params: input?.params,
        }),
      options,
    ),
    AccountReceiveableLiteModel,
  );
}

export function useGetAccountReceivable(
  input?: getAccountReceivableInput,
  options?: UseQueryOptions<ApiResult<AccountReceivableModel>, ApiError>,
): UseQueryResult<ApiResult<AccountReceivableModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['account-receivables', input?.id],
      () =>
        QueryFetchFunction({
          url: `account-receivables/${input?.id}`,
        }),
      options,
    ),
    AccountReceivableModel,
  );
}

export function useGetAccountReceivableCustomer(
  input?: getAccountReceivableAgentInput,
  options?: UseQueryOptions<
    ApiResult<AccountReceiveableCustomerLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ApiResult<AccountReceiveableCustomerLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      [
        'customers',
        input?.id,
        'receivable-sales',
        input?.params,
        ...(input?.othersKeys || []),
      ],
      () =>
        QueryFetchFunction({
          url: `customers/${input?.id}/receivable-sales`,
          params: input?.params,
        }),
      options,
    ),
    AccountReceiveableCustomerLiteModel,
  );
}

export function getAccountReceivablesKey(input?: getAccountReceivablesInput) {
  return ['account-receivables', input?.params];
}

export function getAccountReceivableKey(input?: getAccountReceivableInput) {
  return ['account-receivables', input?.id];
}

export function getAccountReceivableAgentKey(
  input?: getAccountReceivableAgentInput,
) {
  return [
    'agents',
    input?.id,
    'receivable-sales',
    input?.params,
    ...(input?.othersKeys || []),
  ];
}
